import {Suspense as ReactSuspense} from "react";
export const Suspense = (props) => {
  //stop debugger here to see if/when a suspense receives an update before rendering is completed
  return <ReactSuspense {...props} />
}